import SceneObject from "../scene/sceneobject";
import { Aabb } from "./aabb";
import { CollisionVolume } from "./collision_volume";

export default class BoxCollisionVolume implements CollisionVolume {
  owner: SceneObject | null = null;
  layer: string;
  isTrigger: boolean;

  localMin: Float32Array;
  localMax: Float32Array;

  constructor(
    width: number,
    height: number,
    depth: number,
    offset_x: number = 0,
    offset_y: number = 0,
    offset_z: number = 0,
    layer: string = "default",
    isTrigger: boolean = false
  ) {
    const hw = width  * 0.5;
    const hh = height * 0.5;
    const hd = depth  * 0.5;

    this.localMin = new Float32Array([
      offset_x - hw,
      offset_y - hh,
      offset_z - hd,
    ]);

    this.localMax = new Float32Array([
      offset_x + hw,
      offset_y + hh,
      offset_z + hd,
    ]);

    this.layer = layer;
    this.isTrigger = isTrigger;
  }

  static from_min_max(
    localMin: Float32Array,
    localMax: Float32Array,
    layer: string = "default",
    isTrigger: boolean = false
  ): BoxCollisionVolume {
    const box = Object.create(BoxCollisionVolume.prototype) as BoxCollisionVolume;
    box.owner = null;
    box.localMin = localMin;
    box.localMax = localMax;
    box.layer = layer;
    box.isTrigger = isTrigger;
    return box;
  }

  set_size(width: number, height: number, depth: number): void {
    const cx = (this.localMin[0] + this.localMax[0]) * 0.5;
    const cy = (this.localMin[1] + this.localMax[1]) * 0.5;
    const cz = (this.localMin[2] + this.localMax[2]) * 0.5;

    const hw = width  * 0.5;
    const hh = height * 0.5;
    const hd = depth  * 0.5;

    this.localMin[0] = cx - hw;
    this.localMin[1] = cy - hh;
    this.localMin[2] = cz - hd;

    this.localMax[0] = cx + hw;
    this.localMax[1] = cy + hh;
    this.localMax[2] = cz + hd;
  }

  set_offset(x: number, y: number, z: number): void {
    const w = this.localMax[0] - this.localMin[0];
    const h = this.localMax[1] - this.localMin[1];
    const d = this.localMax[2] - this.localMin[2];

    const hw = w * 0.5;
    const hh = h * 0.5;
    const hd = d * 0.5;

    this.localMin[0] = x - hw;
    this.localMin[1] = y - hh;
    this.localMin[2] = z - hd;

    this.localMax[0] = x + hw;
    this.localMax[1] = y + hh;
    this.localMax[2] = z + hd;
  }


  getWorldAabb(): Aabb | null {
    if (!this.owner) return null;

    const p = this.owner.transform.position;

    return {
      min: new Float32Array([
        p[0] + this.localMin[0],
        p[1] + this.localMin[1],
        p[2] + this.localMin[2],
      ]),
      max: new Float32Array([
        p[0] + this.localMax[0],
        p[1] + this.localMax[1],
        p[2] + this.localMax[2],
      ]),
    };
  }

  getWorldSphere():null {
    return null;
  }
}